/**
 * Utility for safely accessing environment variables across Vite and Webpack builds
 */

/**
 * Validate and return a required environment variable
 * Throws with a clear error message if the value is missing
 */
export function requireEnv(value: string | undefined, varName: string): string {
  if (!value) {
    throw new Error(
      `Missing required environment variable: ${varName}. ` +
      `Configure in your .env file.`
    )
  }
  return value
}

/**
 * Get an optional environment variable with a fallback value
 */
export function optionalEnv(value: string | undefined, fallback: string): string {
  return value || fallback
}
